import { render } from "./StatsPanel.vue?vue&type=template&id=fcf9ab8a"
import script from "./StatsPanel.vue?vue&type=script&lang=js"
export * from "./StatsPanel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__